module.exports = {"label":{"calls":"Anrufliste","resources":"Systemstatus"}}